module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-105df623b645c544370343f6e4413033.webp";